import { ClientContext } from '@ms/yammer-data/dist/telemetry';

import { getUserAgentDetails } from '../userAgent';

export type GetClientContext = (hostClientType?: string) => ClientContext;

const getClientContext: GetClientContext = (hostClientType) => {
  const { osName, deviceType } = getUserAgentDetails();

  return {
    osName,
    deviceType,
    hostClientType,
  };
};

export default getClientContext;
